import { render } from "./RequestUpdate.vue?vue&type=template&id=19dd7bc6"
import script from "./RequestUpdate.vue?vue&type=script&lang=js"
export * from "./RequestUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__